// frontend/admin-portal/src/components/dashboard/ProductsOverview.jsx
import React from "react";
import { Alert, Spinner, Button, Panel } from "@fiberhome/shared-ui";

export default function ProductsOverview({ slice, onViewAll }) {
  const { data, loading, error } = slice;

  const total = Number(data?.total) || 0;
  const pct = (n) => (total > 0 ? Math.round((Number(n) / total) * 100) : 0);

  return (
    <Panel
      title="Products Overview"
      subtitle="Catalog health at a glance"
      tone="primary"
      actions={
        onViewAll && (
          <Button variant="ghost" size="sm" onClick={onViewAll}>
            View all →
          </Button>
        )
      }
    >
      {loading && (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <Spinner size="sm" />
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && data && (
        <div className="fh-statbar">
          <StatBar
            label="Total products"
            value={total}
            pct={100}
            color="#0d6efd"
          />
          <StatBar
            label="Active"
            value={data.active ?? 0}
            pct={pct(data.active)}
            color="#198754"
          />
          <StatBar
            label="Low stock"
            value={data.lowStock ?? 0}
            pct={pct(data.lowStock)}
            color="#f59e0b"
          />
          <StatBar
            label="Out of stock"
            value={data.outOfStock ?? 0}
            pct={pct(data.outOfStock)}
            color="#dc3545"
          />
        </div>
      )}
    </Panel>
  );
}

function StatBar({ label, value, pct, color }) {
  return (
    <div className="fh-statbar__row">
      <div className="fh-statbar__label-row">
        <span className="fh-statbar__label">{label}</span>
        <span className="fh-statbar__value">{value}</span>
      </div>
      <div className="fh-statbar__track">
        <div
          className="fh-statbar__fill"
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
    </div>
  );
}
